import { ImageFit } from "@fluentui/react";
import CControl from "./CControl";
import { IFieldSchema } from "./IFieldSchema";
import { CForm } from "./JSForm";

export interface ICCardProps {
    form?: CForm;
    schema: IFieldSchema;
}

export default class CCard extends CControl {

    #props: ICCardProps;

    constructor(props: ICCardProps) {
        super({ form: props.form, schema: props.schema });
        this.#props = props;
    }

    get previewImageSrc(): string {
        return this.#props.schema.previewImageSrc;
    }

    get iconSrc(): string {
        return this.#props.schema.iconSrc;
    }

    get imageFit(): ImageFit {
        return this.#props.schema.imageFit;
    }

    get title(): string {
        return this.#props.schema.title;
    }

    get activity(): string {
        return this.#props.schema.activity;
    }

    get height(): string {
        return this.#props.schema.height;
    }

    get width(): string {
        return this.#props.schema.width;
    }

    get showAsSecondaryTitle(): boolean {
        return this.#props.schema.showAsSecondaryTitle ?? false;
    }

}